/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { classWithModifiers } from '~/react/componentHelper';
import HamburgerSVG from '~/public/assets/icons/hamburger.svg';

const Hamburger = ({ modifiers }) => {
  const cetDataVars = {
    'data-vars-item-name': 'menu_nav',
    'data-vars-item-type': 'button',
    'data-vars-action-type': 'open',
    'data-vars-action-value': 'menu',
    'data-vars-unit-type': 'nav_bar',
    'data-vars-unit-name': 'site_header',
    'data-vars-type': 'web_content_action',
    'data-vars-subunit-type': 'component',
    'data-vars-subunit-name': 'hamburger_nav',
    'data-vars-position-in-subunit': 0,
  };
  return (
    <button
      className={`hamburger-btn ${classWithModifiers('hamburger', modifiers)}`}
      aria-label="Open main menu"
      {...cetDataVars}
    >
      <HamburgerSVG />
    </button>
  );
};

export default Hamburger;

Hamburger.propTypes = {
  modifiers: PropTypes.arrayOf(PropTypes.string),
};

Hamburger.defaultProps = {
  modifiers: [],
};

